module.exports = __webpack_public_path__ + "img/jane-min.c1b5e3c9.png";